import { render, staticRenderFns } from "./one_sectionhome.vue?vue&type=template&id=fff437a4&"
import script from "./one_sectionhome.vue?vue&type=script&lang=js&"
export * from "./one_sectionhome.vue?vue&type=script&lang=js&"
import style0 from "./one_sectionhome.vue?vue&type=style&index=0&id=fff437a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports